/**
 * Production is served behind nginx, so the API and Socket.IO share the page
 * origin. Falling back to localhost in a release bundle sends every browser
 * to its own machine and makes sign-in look like a network outage.
 */
const pageOrigin = typeof window === 'undefined' ? '' : window.location.origin;
const isLocalPage =
  typeof window !== 'undefined' &&
  ['localhost', '127.0.0.1'].includes(window.location.hostname);

/**
 * A root development .env is shared by the workspaces. Vite exposes its
 * localhost URLs during a production build too, so reject those values when
 * the app is running on a public host. Otherwise every visitor tries to call
 * port 4000 on their own device and sign-in appears offline.
 */
function publicSafeUrl(configured: string | undefined, fallback: string): string {
  if (!configured) return fallback;
  if (isLocalPage) return configured;

  try {
    const hostname = new URL(configured).hostname;
    if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1') {
      return fallback;
    }
  } catch {
    return fallback;
  }

  return configured;
}

export const API_URL = publicSafeUrl(
  import.meta.env.VITE_API_URL,
  isLocalPage ? 'http://localhost:4000' : pageOrigin,
);
export const SFU_URL = publicSafeUrl(
  import.meta.env.VITE_SFU_URL,
  isLocalPage ? 'http://localhost:4100' : pageOrigin,
);
export const EASYRTC_URL =
  import.meta.env.VITE_EASYRTC_URL ??
  (isLocalPage ? 'http://localhost:4200' : 'https://vc.itsappy.com');
